module.exports = __webpack_public_path__ + "img/success.c39cc398.svg";